// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"styles_dropzone__1ZrKY","dropzone_label":"styles_dropzone_label__1DoDR"};